var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, select } from 'redux-saga/effects';
import { getProductsData } from '../../selectors';
import { getLoadModuleFetchConfig } from '../../../utils/get-load-module-fetch-config';
import { findRouteFromList } from '../../../utils/find-route-from-list';
import { customLoadI18NextModule } from './_utils/custom-load-i18next-module';
import { injectUrlsData } from './_utils/inject-urls-data';
import { loadChildrenRoutes } from './_utils/load-children-routes';
var cachedScripts = {};
export function prefetchRouteWorkerSaga(_a) {
    var externalPackages, productsMenuItems, routeItem, staticURL, config, fetchConfig_1, routes, _b, params, i18n, loadAction, windowUrlsPath_1, serviceEnvs, urlsData, _c, error_1;
    var _d, _e;
    var menuName = _a.menuName, routeName = _a.routeName, loadModuleFunction = _a.loadModuleFunction, router = _a.router, store = _a.store, mobilePrefetch = _a.mobilePrefetch;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 13, , 14]);
                externalPackages = (store.getDependencies() || {}).externalPackages;
                return [4 /*yield*/, select(getProductsData)];
            case 1:
                productsMenuItems = _f.sent();
                routeItem = productsMenuItems.find(findRouteFromList({ menuName: menuName, routeName: routeName }));
                if (!routeItem) {
                    return [2 /*return*/];
                }
                // если нет staticURL или config то префетч может привести к ошибочным запросам
                // нужно загружать такой сервис при непосредственном переходе на него
                if (!routeItem.staticURL ||
                    !routeItem.config ||
                    cachedScripts[routeItem.staticURL]) {
                    return [2 /*return*/];
                }
                staticURL = routeItem.staticURL, config = routeItem.config;
                fetchConfig_1 = getLoadModuleFetchConfig({
                    config: routeItem.config,
                    staticURL: staticURL,
                    name: routeItem.name,
                    loadModuleFunction: loadModuleFunction,
                    router: router,
                    externalPackages: externalPackages,
                });
                return [4 /*yield*/, all([
                        call(function () { return fetchConfig_1[0]; }),
                        call(function () { return fetchConfig_1[1]; }),
                    ])];
            case 2:
                routes = (_f.sent())[0];
                if (!routes) {
                    return [2 /*return*/];
                }
                _b = routes[0], params = _b.params, i18n = _b.i18n, loadAction = _b.loadAction;
                windowUrlsPath_1 = ((_d = params === null || params === void 0 ? void 0 : params.endpointsConfig) === null || _d === void 0 ? void 0 : _d.fromWindow)
                    ? "".concat(staticURL, "/umd/runtime-config.js")
                    : '';
                serviceEnvs = config === null || config === void 0 ? void 0 : config.envs;
                if (!((i18n === null || i18n === void 0 ? void 0 : i18n.namespaces) && !config.i18nNamespace)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(customLoadI18NextModule, {
                        namespaces: i18n.namespaces,
                        router: router,
                        version: config.version,
                        localDictionaryFiles: i18n.localDictionaryFiles,
                    })];
            case 3:
                _f.sent();
                _f.label = 4;
            case 4:
                if (!((_e = params === null || params === void 0 ? void 0 : params.endpointsConfig) === null || _e === void 0 ? void 0 : _e.fromWindow)) return [3 /*break*/, 8];
                if (!(serviceEnvs && serviceEnvs !== 'RUNTIME_ENVS')) return [3 /*break*/, 5];
                _c = serviceEnvs;
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, call(function () {
                    return fetch(windowUrlsPath_1, {
                        cache: 'no-store',
                    }).then(function (data) { return data.text(); });
                })];
            case 6:
                _c = _f.sent();
                _f.label = 7;
            case 7:
                urlsData = _c;
                injectUrlsData({ urlsData: urlsData, windowUrlsPath: windowUrlsPath_1 });
                _f.label = 8;
            case 8:
                if (!mobilePrefetch) return [3 /*break*/, 10];
                return [4 /*yield*/, call(loadAction)];
            case 9:
                _f.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, call(loadChildrenRoutes, [routes[0]])];
            case 11:
                _f.sent();
                _f.label = 12;
            case 12:
                cachedScripts[staticURL] = true;
                return [3 /*break*/, 14];
            case 13:
                error_1 = _f.sent();
                console.error('error in prefetchRouteWorkerSaga', error_1.message);
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
